import { ApplicationRolePermissions } from '@organization/api/requests'
import { Divider, Flex, Form, Switch, Typography } from 'antd'

type Props = {
  label?: React.ReactNode
  applicationId?: number
  value: string
  name: string
}

export const PermissionsSwitch = ({
  label,
  applicationId,
  name,
  value
}: Props) => {
  const form = Form.useFormInstance()
  const applicationValue = Form.useWatch(name) as
    | ApplicationRolePermissions[]
    | undefined

  const handleChange = () => {
    if (!applicationId) return

    const permissions = (form.getFieldValue(name) ||
      []) as ApplicationRolePermissions[]

    const permissionIndex = permissions.findIndex(
      (p) => p.application === applicationId
    )

    if (permissionIndex !== -1) {
      const newPermission = permissions[permissionIndex]

      permissions[permissionIndex] = {
        ...newPermission,
        permissions: newPermission?.permissions?.includes(value)
          ? newPermission.permissions.filter((v) => v !== value)
          : [...(newPermission.permissions || []), value]
      }
    } else {
      permissions.push({ application: applicationId, permissions: [value] })
    }

    form.setFieldValue(name, [...permissions])
  }

  const checked = applicationValue?.some(
    ({ application, permissions }) =>
      application === applicationId && permissions?.includes(value)
  )

  return (
    <Form.Item noStyle name={name}>
      <Flex gap={8} justify="space-between">
        <Typography>{label}</Typography>
        <Switch checked={checked} onChange={handleChange} />
      </Flex>

      <Divider className="m-0" />
    </Form.Item>
  )
}
